import { render, staticRenderFns } from "./view_notes_list.vue?vue&type=template&id=04c84cf8&scoped=true"
import script from "./view_notes_list.vue?vue&type=script&lang=js"
export * from "./view_notes_list.vue?vue&type=script&lang=js"
import style0 from "./view_notes_list.vue?vue&type=style&index=0&id=04c84cf8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c84cf8",
  null
  
)

export default component.exports